import React, {
  useEffect,
  useState,
  useContext,
  useCallback,
  useMemo,
  useRef,
} from 'react';
import {
  useTheme,
  Tab,
  Tabs,
  Box,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  Button,
  Chip,
  FormHelperText,
} from '@material-ui/core';
import { useLocation, history } from 'umi';
import qs from 'qs';
import PauseCircleFilledIcon from '@material-ui/icons/PauseCircleFilled';
import TouchAppIcon from '@material-ui/icons/TouchApp';
import CreateIcon from '@material-ui/icons/Create';
import FavoriteIcon from '@material-ui/icons/Favorite';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import PlayCircleFilledIcon from '@material-ui/icons/PlayCircleFilled';
import ReactEcharts from 'echarts-for-react';
import { ThemeContext } from 'styled-components';
import dayjs from 'dayjs';
import Alert from '@material-ui/core/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import ErrorIcon from '@material-ui/icons/Error';
import ReplayIcon from '@material-ui/icons/Replay';
import SearchIcon from '@material-ui/icons/Search';
import { useForm, Controller } from 'react-hook-form';
import TooltipsML from '@/components/TooltipsML/TooltipsML';
import SvgIconML from '@/components/SvgIconML/SvgIconML';
import { fmtThousand, fmtPercent } from '@/utils/comUtil';
import { BrandContext } from '@/contexts/ContextProviders';
import DateRangePickerML from '@/components/DateRangePickerML';
import { useSelector, useDispatch } from 'dva';
import LabelManageResultStyled from './LabelManageResultStyled';
import DataTableNativeML from '@/components/DataTableNativeML';
import DialogDataML from '@/components/DialogDataML/DialogDataML';
import webStorage from '@/utils/storageManager';

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function getStyles(name, arr, theme) {
  return {
    fontWeight:
      arr.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
    color: '#000',
  };
}

const LabelManageResult = (props) => {
  const OPT_PROFILE_TAG_VIEW = webStorage
    .get('USER')
    ?.authorities?.includes('OPT_PROFILE_TAG_VIEW');
  const OPT_PROFILE_TAG_VIEW_DOWN = webStorage
    .get('USER')
    ?.authorities?.includes('OPT_PROFILE_TAG_VIEW_DOWN');
  const MENU_USER_PROFILE_TAG_VIEW_RULE = webStorage
    .get('USER')
    ?.authorities?.includes('MENU_USER_PROFILE_TAG_VIEW_RULE');
  const MENU_USER_PROFILE_TAG_ENABLE_DISABLE = webStorage
    .get('USER')
    ?.authorities?.includes('MENU_USER_PROFILE_TAG_ENABLE_DISABLE');
  const MENU_USER_PROFILE_TAG_MANUAL_CALCULATE = webStorage
    .get('USER')
    ?.authorities?.includes('MENU_USER_PROFILE_TAG_MANUAL_CALCULATE');

  const dispatch = useDispatch();
  const {
    setModification = () => {},
    isSearch,
    setIsSearch = () => {},
    tagId,
    fetchTagTree,
  } = props;
  const location = useLocation();
  const { query, pathname } = location;

  // const { query } = props;
  const { signUpDateEnd, signUpDateStart } = query;

  const { handleSubmit, control, getValues, setValue } = useForm({
    defaultValues: {
      date: { startDate: signUpDateStart, endDate: signUpDateEnd },
    },
  });

  const timestamp = dayjs().format('YYYY-MM-DD HH-mm-ss');
  const [isResetDefalut, setIsResetDefalut] = useState(false);
  const themeContext = useContext(ThemeContext);
  const brandContext = useContext(BrandContext);
  const { charts } = themeContext[brandContext];
  const { chartsFontSize, fontFamily } = themeContext.comm;

  const theme = useTheme();
  const [echartsOptions, setEchartsOptions] = useState({});

  const [tabValue, setTabValue] = React.useState(0);
  const [isLike, setIsLike] = useState();
  const [calculate, setCalculate] = useState();
  const [start, setStart] = useState();
  const [setList, setSetList] = useState([]);
  // 集合数组
  const [tagIds, setTagIds] = useState([]);
  const [calculateOpen, setCalculateOpen] = useState(false);

  const [columnSort, setColumnSort] = useState();
  const [isColumnSort, setIsColumnSort] = useState(true);
  const [isOtherColumnSort, setIsOtherColumnSort] = useState(true);
  const [page, setPage] = useState({ pageNum: 1, pageSize: 10 });
  const [isHistorySearch, setIsHistorySearch] = useState(false);

  // computeStatus
  // 计算状态 1-成功 2-失败 3-计算中 4-等待计算 5-延迟计算
  // 状态 1-启用 2-停用
  const tagMember = useSelector((state) => state.labelManage.tagMember);
  const { tagCollectionInfoList, tagNotCollectionInfoList } = tagMember || [];
  const tagInfo = useSelector((state) => state.labelManage.tagInfo) || {};
  const {
    // id,
    name,
    computeStatus,
    status,
    type,
    remark,
    id: labelId,
    updateStrategyName,
    ruleTypeName,
    typeName,
    ruleType,
  } = tagInfo || {};
  const labelInfo = [
    { label: 'ID', value: labelId },
    { label: '更新方式', value: updateStrategyName },
    { label: '创建类型', value: typeName },
    { label: '标签类型', value: ruleTypeName },
  ];
  const initId = tagInfo?.id;
  const tab = query.tab ?? 0;
  const id = query.id ?? initId;
  // tagHistory 标签历史
  const tagHistory = useSelector((state) => state.labelManage.tagHistory);
  const { data: tagHistoryData } = tagHistory || [];
  const { total: historyTotal } = tagHistory;
  const [alertOpen, setAlertOpen] = useState(false);
  const treemapRef = useRef(null);

  const tagHistoryDataList = useMemo(() => {
    tagHistoryData &&
      tagHistoryData.forEach((item) => {
        const list = {};
        item.profileTagHistoryInfoList.forEach((element) => {
          list[element.baseDate] = element.quantity || '-';
        });
        // eslint-disable-next-line no-param-reassign
        item = Object.assign(item, list);
      });
    return tagHistoryData;
  }, [tagHistoryData]);

  // 类型 1-集合类型 2-文本类型标签 3-数值类型标签 4-日期类型标签 5-SQL类型 6-文件类型
  // 收藏列表，需要进行匹配
  const favoriteList = useSelector((state) => state.labelManage.favoriteList);
  const favoriteIdList = useMemo(() => {
    const data = [];
    favoriteList &&
      favoriteList.forEach((item) => {
        data.push(item.tagId);
      });
    return data;
  }, [favoriteList]);

  const dateDiffListData = useMemo(() => {
    const dayDiff = dayjs(signUpDateEnd).diff(dayjs(signUpDateStart), 'day');
    var stipe = signUpDateStart;
    const diffData = [];
    for (let i = 0; i < dayDiff; i++) {
      const stimeTs = new Date(stipe).getTime();
      const nextDate = stimeTs + 24 * 60 * 60 * 1000;
      const nextDatesY = new Date(nextDate).getFullYear() + '-';
      const nextDatesM =
        new Date(nextDate).getMonth() + 1 < 10
          ? '0' + (new Date(nextDate).getMonth() + 1) + '-'
          : new Date(nextDate).getMonth() + 1 + '-';
      const nextDatesD =
        new Date(nextDate).getDate() < 10
          ? '0' + new Date(nextDate).getDate()
          : new Date(nextDate).getDate();
      diffData[i] = nextDatesY + nextDatesM + nextDatesD;
      stipe = dayjs(stipe).add(1, 'day');
    }
    const dayFirst = dayjs(signUpDateStart).format('YYYY-MM-DD');
    diffData.push(dayFirst);
    return diffData.sort();
  }, [signUpDateStart, signUpDateEnd]);

  const dateColumnList = useMemo(() => {
    const dateList = [...dateDiffListData];
    const newData = [];
    dateList &&
      dateList.forEach((i) => {
        const list = {
          title: dayjs(i).format('MM-DD'),
          align: 'center',
          id: i,
          key: i,
          width: 140,
          frontSort: true,
          render: (item) => (item[i] ? fmtThousand(item[i], 0) : ''),
        };
        newData.push(list);
      });
    return newData;
  }, [dateDiffListData]);

  const tableColumn = useMemo(() => {
    const columns = [
      {
        title: '名称',
        align: 'center',
        id: 'name',
        key: 'name',
        width: 140,
      },
    ];
    return columns.concat(dateColumnList);
  }, [dateColumnList]);

  useMemo(() => {
    if (favoriteList?.length === 0) {
      setIsLike(false);
    }
    setIsLike(favoriteIdList?.includes(Number(tagId)));
  }, [favoriteIdList, favoriteList?.length, tagId]);

  useMemo(() => {
    const statusMap = new Map([
      [1, true],
      [2, true],
      [3, false],
      [4, true],
      [5, false],
    ]);
    setCalculate(statusMap.get(computeStatus));
  }, [computeStatus]);

  useMemo(() => {
    const statusMap = new Map([
      [1, true],
      [2, false],
    ]);
    setStart(statusMap.get(status));
  }, [status]);

  useEffect(() => {
    if (type === 1) {
      setSetList(tagCollectionInfoList);
    } else {
      setSetList(tagNotCollectionInfoList);
    }
  }, [tagCollectionInfoList, type, tagNotCollectionInfoList]);

  const getOption = useCallback(() => {
    let yDataUse = [];
    let newYDataUse = [];
    let seriesData = [];
    let seriesDataType = [];
    const newList = {
      name: name,
      value: tagMember?.quantity,
    };
    tagCollectionInfoList &&
      tagCollectionInfoList.forEach((element) => {
        yDataUse.push(element.name);
        const list = {
          percent: element.percent,
          value: element.quantity,
        };
        seriesData.push(list);
      });
    if (tagNotCollectionInfoList && tagNotCollectionInfoList.length > 0) {
      tagNotCollectionInfoList.forEach((element) => {
        newYDataUse.push(element.label);
        const list = {
          percent: element.percent,
          value: element.quantity,
        };
        seriesDataType.push(list);
      });
    } else {
      newYDataUse.push(name);
      seriesDataType.push(newList);
    }
    let option = {
      textStyle: {
        fontSize: chartsFontSize.s03,
        fontFamily: fontFamily,
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
        textStyle: {
          fontSize: chartsFontSize.s03,
        },
      },
      grid: {
        // width: '100%',
        top: 10,
        left: 10,
        right: 110,
        bottom: 0,
        containLabel: true,
        height: 'auto',
      },
      xAxis: {
        show: false,
        type: 'value',
        // minInterval: 20,
        // maxInterval:20,
        // boundaryGap: [0, 0.01],
        axisTick: true,
        axisLine: true,
        splitLine: {
          show: false,
        },
        max: tagMember?.quantity,
      },
      yAxis: {
        // name: formatMessage({ id: 'comm.unit.lbl03' }),
        nameGap: 5,
        nameTextStyle: {
          color: charts.yColor,
          // padding: [0, 20, 0, 0],
        },
        type: 'category',
        data: type === 1 ? yDataUse : newYDataUse, // ['银卡会员', '银卡会员', '银卡会员', '银卡会员'],
        axisTick: true,
        axisLine: true,
        inverse: true, //倒叙
        axisLabel: {
          textStyle: {
            // color: charts.yColor, //坐标值得具体的颜色
            color: '#212121',
            fontSize: chartsFontSize.s03,
          },
          interval: function () {
            return true;
          },
        },
        splitLine: {
          show: false,
        },
        boundaryGap: true,
      },
      // color: charts.barColorList,
      color: '#1565C0',
      series: {
        data: type === 1 ? seriesData : seriesDataType,
        type: 'bar',
        // barGap: 26,
        barWidth: 40,
        barMinWidth: 20,
        barMaxWidth: 20,
        // barMinHeight: 50,
        barCategoryGap: 20,
        itemStyle: {
          normal: {
            label: {
              show: true,
              color: '#1565C0',
              position: 'right',
              fontWeight: 'lighter',
              formatter: function (p) {
                if (
                  type === 1 ||
                  (tagNotCollectionInfoList &&
                    tagNotCollectionInfoList.length > 0)
                ) {
                  return `${fmtThousand(p.data.value)}人 ${fmtPercent(
                    p.data.percent,
                  )}`;
                }
                return `${fmtThousand(tagMember?.quantity)}人 100%`;
              },
            },
          },
        },
      },
    };

    return option;
  }, [
    name,
    tagMember?.quantity,
    tagCollectionInfoList,
    chartsFontSize.s03,
    fontFamily,
    charts.yColor,
    type,
  ]);

  useEffect(() => {
    setEchartsOptions(getOption());
  }, [getOption]);

  useEffect(() => {
    setTabValue(Number(tab));
  }, [tab]);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
    history.replace(
      `${pathname}?${qs.stringify({
        ...query,
        tab: newValue,
        signUpDateEnd: dayjs().format('YYYY-MM-DD'),
        signUpDateStart: dayjs().subtract(7, 'day').format('YYYY-MM-DD'),
      })}`,
    );
  };

  // 是否收藏
  const handleChooseLike = () => {
    // 需要在收藏列表里进行匹配
    dispatch({
      type: 'labelManage/handleFavorite',
      payload: {
        values: {
          tagId: id,
          isFavorite: Boolean(!isLike),
        },
      },
      callback: (res) => {
        if (res.code === 0) {
          window.message.toast({
            type: 'success',
            message: '',
            title: isLike ? '取消收藏成功' : '收藏成功',
          });
          setModification({});
        } else {
          window.message.toast({
            type: 'error',
            message: res.message,
            title: res.message,
          });
        }
      },
    });
    setIsLike(!isLike);
  };

  const handleCalcu = () => {
    setCalculateOpen(true);
  };

  // 点击手工计算
  const handleCalculate = () => {
    dispatch({
      type: 'labelManage/updateComputeStatus',
      payload: {
        values: {
          tagId: id,
          computeStatus: 3,
        },
      },
      callback: (res) => {
        if (res.code === 0) {
          setModification({});
          window.message.toast({
            type: 'success',
            message: '',
            title: '计算中，稍后请刷新页面查看最新数据',
          });
        } else {
          window.message.toast({
            type: 'error',
            message: res.message,
            title: res.message,
          });
        }
      },
    });
    setTimeout(() => {
      setCalculateOpen(false);
    }, 0);
  };

  // 点击暂停开始
  const handleStart = () => {
    // setStart(!start);
    dispatch({
      type: 'labelManage/updateStatus',
      payload: {
        values: {
          tagId: id,
          status: status === 1 ? 2 : 1,
        },
      },
      callback: (res) => {
        if (res.code === 0) {
          fetchTagTree();
          window.message.toast({
            type: 'success',
            message: '',
            title: start ? '暂停成功' : '启用成功',
          });
          setModification({});
        } else {
          window.message.toast({
            type: 'error',
            message: res.message,
            title: res.message,
          });
        }
      },
    });
  };

  const createLabelMap = new Map([
    [5, 'sql'],
    [6, 'import'],
    [2, 'text'],
    [3, 'math'],
    [4, 'date'],
  ]);

  // 获取标签历史
  const fetchTagHistory = useCallback(() => {
    if (tagId) {
      dispatch({
        type: 'labelManage/getQueryTagHistory',
        payload: {
          values: {
            tagId: tagId,
            // 基准日期End
            baseDateEnd: signUpDateEnd,
            baseDateStart: signUpDateStart,
            // 集合标签ID
            collectionIds: tagIds,
            pageNum: 1,
            pageSize: 10,
            sort: 'DESC',
            // timestamp,
          },
        },
      });
    }
  }, [dispatch, tagId, signUpDateEnd, signUpDateStart, tagIds]);

  useEffect(() => {
    if (signUpDateEnd && signUpDateStart) {
      // 树形 收藏点击可搜索 点击查询可以搜索，只有日期变更时不可搜索
      // 只有点击查询才可以搜索
      if (tagId && isSearch) {
        fetchTagHistory();
      }
    }
  }, [
    fetchTagHistory,
    isSearch,
    signUpDateEnd,
    signUpDateStart,
    isHistorySearch,
    tagId,
  ]);

  // 查看/编辑 规则
  const handleGoLabelGul = (opt, sourceOid) => {
    let url = opt === 'edit' ? '_edit' : '_detail';
    webStorage.delete('DELETE_TAG');
    if (type === 234) {
      history.push({
        pathname: '/profile/label_manage/statistics' + url,
        query: { tagId, opt: `${opt}`, type: String(type) },
        sourceOid,
      });
    } else if (type !== 1) {
      const labelUrl = createLabelMap.get(type);
      history.push({
        pathname: `/profile/label_manage/${labelUrl}` + url,
        query: {
          tagId,
          opt: `${opt}`,
          type: String(type),
          chooseLabel: type === 6 ? 'importlabel' : '',
          sourceOid,
        },
      });
    } else {
      history.push({
        pathname: '/profile/label_manage/collection_label' + url,
        query: { tagId, opt: `${opt}`, type: String(type), sourceOid },
      });
    }
  };

  const loadingEffect = useSelector((state) => state.loading);
  const loading = loadingEffect.effects['labelManage/getQueryTagHistory'];

  const title = <>{remark ? remark : <span>暂无备注</span>}</>;

  //查询
  const handleSubmitSuccess = (submitData) => {
    // setIsSearch(true);
    setIsHistorySearch(true);
    fetchTagHistory();
    const propsSubmitData = {
      ...submitData,
      // signUpDateEnd: submitData.date?.endDate ?? signUpDateEnd,
      // signUpDateStart: submitData.date?.startDate ?? signUpDateStart,
    };
    delete propsSubmitData.date;
  };

  // 日期更改
  const handleHistorySearch = (newParam) => {
    setIsSearch(false);
    history.replace(
      `${pathname}?${qs.stringify({
        ...query,
        ...newParam,
        time: timestamp,
      })}`,
    );
  };

  useEffect(() => {
    setTagIds([]);
  }, [tagId]);

  // 点击重置按钮
  const handleReset = () => {
    setIsResetDefalut(true);
    setIsSearch(true);
    const resetSearch = {
      date: {
        endDate: dayjs().format('YYYY-MM-DD'),
        startDate: dayjs().subtract(7, 'day').format('YYYY-MM-DD'),
      },
    };
    setValue('date', resetSearch);
    setSetList(tagCollectionInfoList);
    setTagIds([]);
    history.replace(
      `${pathname}?${qs.stringify({
        ...query,
        time: timestamp,
        signUpDateEnd: dayjs().format('YYYY-MM-DD'),
        signUpDateStart: dayjs().subtract(7, 'day').format('YYYY-MM-DD'),
      })}`,
    );
  };

  // 点击下载
  const handleDownload = () => {
    dispatch({
      type: 'labelManage/getDownloadTagMember',
      payload: {
        values: {
          tagId: id,
          exportTypeId: 7,
        },
      },
      callback(res) {
        if (res.code === 0) {
          setAlertOpen(true);
        }
      },
    });
  };

  // 日期为空校验
  const isDataValid =
    getValues('date')?.startDate === null ||
    getValues('date')?.endDate === null;

  // 日期超过30天校验
  const dateDiffValid =
    dayjs(getValues('date')?.endDate).diff(
      dayjs(getValues('date')?.startDate),
      'day',
    ) > 30;

  const handleClose = () => {
    setCalculateOpen(false);
  };

  // 监听窗口变化
  useEffect(() => {
    // const myChart1 = echarts.init(treemapRef?.current);
    let myChart = treemapRef && treemapRef?.current?.getEchartsInstance();
    window.addEventListener(
      'resize',
      function () {
        myChart.resize();
      },
      false,
    );
    return () => {
      window.removeEventListener('resize', function () {
        myChart.resize();
      });
    };
  }, []);
  const handleCloseAlert = () => {
    setAlertOpen(false);
  };
  console.log('tagNotCollectionInfoList', tagNotCollectionInfoList);
  return (
    <LabelManageResultStyled theme={theme} calculate={calculate} start={start}>
      <Box className="result-content-top">
        <div className="content-top-left">
          <span className="top-bcg"></span>
          <div className="top-content-wrap">
            <div className="tooltip-wrap">
              <div className="tooltip-wrap-content">
                {/* 性别 */}
                {tagInfo?.name}
                <div className="tooltip-content">
                  <TooltipsML
                    title={title}
                    color="#1565C0"
                    isFilled={true}
                  ></TooltipsML>
                </div>
              </div>
              <div className="content-bottom-list">
                <span
                  data-log={JSON.stringify({
                    oid: 'btn_user_profile_label_management_list_edit',
                    events: ['_ev', '_ec'],
                    params: {
                      tag_id: tagId,
                    },
                  })}
                  className={
                    OPT_PROFILE_TAG_VIEW &&
                    [1, 2].includes(tagInfo.computeStatus)
                      ? 'list-edit'
                      : 'list-edit list-edit-disabled'
                  }
                  onClick={() =>
                    OPT_PROFILE_TAG_VIEW &&
                    [1, 2].includes(tagInfo.computeStatus) &&
                    handleGoLabelGul(
                      'edit',
                      'btn_user_profile_label_management_list_edit',
                    )
                  }
                >
                  <CreateIcon
                    className={
                      OPT_PROFILE_TAG_VIEW &&
                      [1, 2].includes(tagInfo.computeStatus)
                        ? 'list-edit-icon'
                        : 'list-edit-icon list-edit-icon-disabled'
                    }
                  />{' '}
                  编辑
                </span>
                <span
                  data-log={JSON.stringify({
                    oid: 'btn_user_profile_label_management_list_download',
                    events: ['_ev', '_ec'],
                    params: {
                      tag_id: tagId,
                    },
                  })}
                  className={
                    OPT_PROFILE_TAG_VIEW_DOWN &&
                    [1].includes(tagInfo.computeStatus)
                      ? 'list-download'
                      : 'list-download list-download-disabled'
                  }
                  onClick={() =>
                    OPT_PROFILE_TAG_VIEW_DOWN &&
                    [1].includes(tagInfo.computeStatus) &&
                    handleDownload()
                  }
                >
                  <SvgIconML
                    size={18}
                    className={
                      OPT_PROFILE_TAG_VIEW_DOWN &&
                      [1].includes(tagInfo.computeStatus)
                        ? 'icon'
                        : 'icon list-download-disabled'
                    }
                    name={'favorite'}
                  ></SvgIconML>
                  下载
                </span>
                <span
                  data-log={JSON.stringify({
                    oid: 'btn_user_profile_label_management_list_collect',
                    events: ['_ev', '_ec'],
                    params: {
                      tag_id: tagId,
                    },
                  })}
                  className="list-like"
                  onClick={() => handleChooseLike()}
                >
                  <div>
                    {
                      <FavoriteBorderIcon
                        sx={{ display: !isLike ? 'initial' : 'none' }}
                      />
                    }
                    {
                      <FavoriteIcon
                        sx={{
                          color: '#1565C0',
                          display: isLike ? 'initial' : 'none',
                        }}
                      />
                    }
                  </div>
                  收藏
                </span>
                <span
                  data-log={JSON.stringify({
                    oid: 'btn_user_profile_label_management_list_view_rule',
                    events: ['_ev', '_ec'],
                    params: {
                      tag_id: tagId,
                    },
                  })}
                  className="list-regular"
                  style={{
                    color: MENU_USER_PROFILE_TAG_VIEW_RULE
                      ? '#1565C0'
                      : '#616161',
                    cursor: MENU_USER_PROFILE_TAG_VIEW_RULE
                      ? 'cursor'
                      : 'not-allowed',
                  }}
                  onClick={() =>
                    MENU_USER_PROFILE_TAG_VIEW_RULE &&
                    handleGoLabelGul(
                      'detail',
                      'btn_user_profile_label_management_list_view_rule',
                    )
                  }
                >
                  查看规则{' '}
                  <span
                    style={{
                      fontSize: '22px',
                      color: MENU_USER_PROFILE_TAG_VIEW_RULE
                        ? '#1565C0'
                        : '#616161',
                      marginLeft: '10px',
                      cursor: MENU_USER_PROFILE_TAG_VIEW_RULE
                        ? 'cursor'
                        : 'not-allowed',
                    }}
                  >
                    {' '}
                    ›
                  </span>
                </span>
              </div>
            </div>
            <div className="content-label-info">
              {labelInfo.map((item) => (
                <Box className="label-box">
                  <Box className="label-box-label">{item.label}</Box>
                  <Box className="label-box-value">{item.value}</Box>
                </Box>
              ))}
            </div>
          </div>
          <span
            data-log={JSON.stringify({
              oid: 'btn_user_profile_label_management_list_enable_disable',
              events: ['_ev', '_ec'],
              params: {
                tag_id: tagId,
              },
            })}
            className={
              MENU_USER_PROFILE_TAG_ENABLE_DISABLE
                ? 'top-icon-bcg'
                : 'top-icon-bcg top-icon-bcg-disabled'
            }
            onClick={() =>
              MENU_USER_PROFILE_TAG_ENABLE_DISABLE && handleStart()
            }
          >
            {start ? (
              <PauseCircleFilledIcon
                className="top-icon"
                sx={{ color: '#fff' }}
              />
            ) : (
              <PlayCircleFilledIcon
                className="top-icon"
                sx={{ color: '#fff' }}
              />
            )}
          </span>
        </div>
        {/* 右侧 */}
        <div
          data-log={JSON.stringify({
            oid: 'btn_user_profile_label_management_list_manual_calculation',
            events: ['_ev', '_ec'],
            params: {
              tag_id: tagId,
            },
          })}
          className={
            MENU_USER_PROFILE_TAG_MANUAL_CALCULATE &&
            [1, 2].includes(tagInfo.computeStatus)
              ? 'content-top-right'
              : 'content-top-right content-top-right-disabled'
          }
          onClick={() =>
            calculate &&
            start &&
            MENU_USER_PROFILE_TAG_MANUAL_CALCULATE &&
            [1, 2].includes(tagInfo.computeStatus) &&
            handleCalcu()
          }
        >
          {/* 125可点 */}
          <TouchAppIcon
            className="right-icon"
            sx={{
              color: '#fff',
              fontSize: '47',
            }}
          ></TouchAppIcon>
          <span>手工计算</span>
        </div>
      </Box>
      <div className="result-list-wrap">
        <Box>
          <Tabs
            value={tabValue}
            onChange={handleChange}
            aria-label="basic tabs"
          >
            <Tab label="标签人数" sx={{ fontSize: '16px' }} {...a11yProps(0)} />
            <Tab label="标签历史" sx={{ fontSize: '16px' }} {...a11yProps(1)} />
          </Tabs>
        </Box>
        <TabPanel className="tab-panel" value={tabValue} index={0}>
          <div className="tab-panel-top">
            <div className="label-people-num">
              <span>人数：</span>
              {fmtThousand(tagMember?.quantity)}
            </div>
            <div className="label-people-date">
              <span></span>
              <div className="people-date-first">
                基准日期：{tagMember?.baseDate}
              </div>
              <div>
                最新成功计算时间：
                {tagMember?.successDateTime}
              </div>
            </div>
          </div>
          <div
            className="panel-charts"
            style={{ height: 'calc(100vh - 526px)', overflowY: 'scroll' }}
          >
            <ReactEcharts
              ref={treemapRef}
              style={{
                width: '100%',
                //  height: 'auto',
                minHeight:
                  (tagNotCollectionInfoList?.length || 0) * 30 + 100 + 'px',
              }}
              option={echartsOptions || {}}
              notMerge={true}
              lazyUpdate={true}
              //   onEvents={onEvents}
            />
          </div>
        </TabPanel>
        <TabPanel className="tab-panel" value={tabValue} index={1}>
          {/* 标签历史 */}
          {/* 搜索条件 */}
          <form onSubmit={handleSubmit(handleSubmitSuccess)}>
            <Box className="label-history-search">
              <div className="history-search-left">
                <FormControl variant="standard" className="single-select">
                  <Controller
                    render={(rp) => (
                      <DateRangePickerML
                        afterDays={30}
                        startText={'开始日期'}
                        endText={'结束日期'}
                        resetStartDate={dayjs()
                          .subtract(7, 'day')
                          .format('YYYY-MM-DD')}
                        defaultStartDate={
                          signUpDateStart === undefined
                            ? dayjs().subtract(7, 'day').format('YYYY-MM-DD')
                            : signUpDateStart
                        }
                        defaultEndDate={
                          // dayjs().format('YYYY-MM-DD')
                          signUpDateEnd === undefined
                            ? dayjs().format('YYYY-MM-DD')
                            : signUpDateEnd
                        }
                        rp={rp}
                        onChange={({ startDate, endDate }) => {
                          handleHistorySearch({
                            signUpDateStart: startDate,
                            signUpDateEnd: endDate,
                          });
                          setIsResetDefalut(false);
                        }}
                        name="custom-form-submit-name"
                        isResetDefalut={isResetDefalut}
                      />
                    )}
                    name="date"
                    control={control}
                    rules={{
                      // required: true,
                      validate: () => {
                        const validateDate = !(
                          getValues('date').startDate === null ||
                          getValues('date').endDate === null
                        );
                        const dateStatus = dayjs(
                          getValues('date')?.endDate,
                        ).diff(dayjs(getValues('date')?.startDate), 'day');
                        return dateStatus < 31 && validateDate;
                      },
                    }}
                  />
                  <FormHelperText error={Boolean(isDataValid)}>
                    {isDataValid && '日期不得为空'}
                  </FormHelperText>
                  <FormHelperText error={Boolean(dateDiffValid)}>
                    {dateDiffValid && '日期间隔不得大于31天'}
                  </FormHelperText>
                </FormControl>
                {(type === 1 || (type === 234 && ruleType === 1)) && (
                  <Controller
                    // className="multiple-select"
                    render={(pr) => (
                      <FormControl
                        // sx={{ m: 1, width: 540 }}
                        sx={{ flex: '1 auto' }}
                        variant="standard"
                        // className="multiple-select"
                        className={tagIds?.length > 0 ? 'multiple-select' : ''}
                      >
                        <InputLabel id="demo-multiple-chip-label">
                          {type === 1 ? '集合' : '枚举'}
                        </InputLabel>
                        <Select
                          labelId="demo-multiple-chip-label"
                          id="demo-multiple-chip"
                          multiple
                          value={tagIds}
                          // value={companyId || deCompanyId}
                          onChange={(e) => {
                            // handleSelectChange(e);
                            const value = e.target.value;
                            setIsSearch(false);
                            setTagIds(
                              typeof value === 'string'
                                ? value.split(',')
                                : value,
                            );
                            return pr.onChange(e.target.value);
                          }}
                          renderValue={(selected) => {
                            return Array.isArray(selected) &&
                              selected.length > 0 ? (
                              <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                                {selected.map((value) => (
                                  <Chip
                                    key={value}
                                    label={(() => {
                                      const data = setList?.find(
                                        (item) => item.id === value,
                                      );
                                      return <>{data?.name || data?.label}</>;
                                    })()}
                                    sx={{ m: '2px' }}
                                  />
                                ))}
                              </Box>
                            ) : (
                              ''
                            );
                          }}
                          MenuProps={MenuProps}
                        >
                          {Array.isArray(setList) &&
                            setList.length > 0 &&
                            setList.map((data) => (
                              <MenuItem
                                key={data.id}
                                value={data.id}
                                style={getStyles(data.id, tagIds, theme)}
                              >
                                {data?.name || data?.label}
                              </MenuItem>
                            ))}
                        </Select>
                      </FormControl>
                    )}
                    control={control}
                    name="companies"
                  />
                )}
              </div>
              <div className="search-right">
                <Button
                  variant="contained"
                  color="secondary"
                  className="reset"
                  onClick={handleReset}
                  startIcon={
                    <ReplayIcon sx={{ width: '16px', height: '16px' }} />
                  }
                >
                  重置
                </Button>
                <Button
                  variant="contained"
                  type="submit"
                  className="search"
                  startIcon={
                    <SearchIcon sx={{ width: '16px', height: '16px' }} />
                  }
                >
                  查询
                </Button>
              </div>
            </Box>
          </form>
          <div className="label-table-wrap">
            <DataTableNativeML
              total={historyTotal}
              loading={loading}
              columns={tableColumn}
              devicesMinWidth="auto"
              data={tagHistoryDataList}
              np={true}
              paging={true}
              page={page}
              changePage={(pageObj) => {
                setPage(pageObj);
              }}
              columnSort={columnSort}
              setColumnSort={setColumnSort}
              isColumnSort={isColumnSort}
              setIsColumnSort={setIsColumnSort}
              isOtherColumnSort={isOtherColumnSort}
              setIsOtherColumnSort={setIsOtherColumnSort}
              isFrontSort={true}
            ></DataTableNativeML>
          </div>
        </TabPanel>
        <DialogDataML
          open={calculateOpen}
          title={'手工计算'}
          content={'确定要手工计算吗'}
          handleClose={handleClose}
          handleConfirm={handleCalculate}
        ></DialogDataML>
      </div>
      <Snackbar
        open={alertOpen}
        autoHideDuration={3000}
        onClose={handleCloseAlert}
        anchorOrigin={{ vertical: 'top', horizontal: 'top' }}
      >
        <Alert
          severity="info"
          sx={{
            width: '419px',
            backgroundColor: '#E5F6FD',
            fontSize: '14px',
            lineHeight: '22px',
          }}
          iconMapping={{
            info: <ErrorIcon fontSize="inherit" sx={{ color: '#2094D6' }} />,
          }}
        >
          标签包导出中，可在我的任务查看导出结果
        </Alert>
      </Snackbar>
    </LabelManageResultStyled>
  );
};

export default LabelManageResult;
